import { Map } from 'immutable';
import reducerChain from '../helpers/chain';
import Constants from '../../constants/index';
import { AnswerRecord } from '../../records/index';
import {
	reducerMerger,
	reducerRemover,
	reducerUpdateVoteCountInContent,
} from '../helpers/entities';

export const DEFAULT_STATE = Map({});

const answersDefault = reducerMerger(
	[Constants.FETCH_ANSWERS, Constants.FETCH_ANSWER],
	'answers',
	AnswerRecord,
);

const answersWithVotes = reducerUpdateVoteCountInContent([Constants.VOTE_UP, Constants.VOTE_DOWN]);

const answersWithDelete = reducerRemover(Constants.DELETE_ANSWER);

export default reducerChain([answersDefault, answersWithVotes, answersWithDelete], DEFAULT_STATE);
